// Shared status presentation for outbound message pages (Index and Show)
const OUTBOUND_STATUS: Record<string, { label: string; badge: string }> = {
  draft: { label: 'Rascunho', badge: 'bg-blue-100 text-blue-800' },
  active: { label: 'Ativa', badge: 'bg-green-100 text-green-800' },
  paused: { label: 'Pausada', badge: 'bg-yellow-100 text-yellow-800' },
  completed: { label: 'Concluída', badge: 'bg-gray-100 text-gray-800' },
}

export function outboundStatus(status: string): { label: string; badge: string } {
  return OUTBOUND_STATUS[status] ?? OUTBOUND_STATUS.draft
}
